import { Box } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import { useShiftsToDisplay } from 'modules/shift_management/hooks/useShiftsToDisplay'
import type { Shift, ShiftsRow } from 'modules/shift_management/lib/types'

import BaseShift from './BaseShift'

interface Props {
  shifts: Shift[]
  shiftsRow: ShiftsRow
  date: moment.Moment
}

const ShiftCell = ({ shifts, shiftsRow, date }: Props) => {
  const { shiftsToDisplay, previewPlannedBreaks } = useShiftsToDisplay({
    shifts,
    shiftsRow,
    date,
  })

  if (!shiftsToDisplay.length) return <></>

  return (
    <Box gap="s4">
      {shiftsToDisplay.map((shift, index) => (
        <BaseShift
          date={date}
          shiftsRow={shiftsRow}
          shift={shift}
          key={`BaseShiftCell-${shift.id || index}`}
          isNightShift={false}
          preview={shift.preview}
          previewPlannedBreaks={shift.preview ? previewPlannedBreaks : undefined}
        />
      ))}
    </Box>
  )
}

export default observer(ShiftCell)
